import "@fontsource/material-icons-outlined";

import $ from './app/jquery-shim.js';
import "core-js";
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import modal from './app/modal.js';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';


import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


import "./simulation/index";




class ScrollReveal {
  constructor(options){
    this.options = options;
  }

  reveal(el, options, duration){
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire( el, function(){
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options,args);
      anime(args);
    }, {
      offset: window.innerHeight
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();



    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;



      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
        });
      });

      owls.imagesLoaded(function () {
        if ($('.c-box-top-banner__content').find('.c-box-top-banner__block').length < 4){
          $('.c-box-top-banner__content').toggleClass('owl-carousel');
          return false;
        }
        $('.c-box-top-banner__content').owlCarousel({
          items: 3,
          margin: 15,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 2,
              margin: 8,
              slideBy: 1,
              center: false,
              dotsEach: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.js-card-slider').find('.c-card__block').length < 3){
          $('.js-card-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });


      if(document.getElementById('voiceDatas')){
        fetch('/wp-json/wp/custom/voice')
          .then(response => response.json())
          .then((data) => {
            let html = '';

            data.forEach((item) => {
              const imageUrl = item.image || ''; // デフォルトの空文字
              const companyName = item.companyname || ''; // デフォルトの空文字
              const title = typeof item.title === 'string' ? item.title : JSON.stringify(item.title); // titleがオブジェクトの場合、JSON形式に変換

              html += `
              <a class="c-card-voice__block" href="${item.link}">
                <div class="c-card-voice__image">
                  <div class="bg-img" style="background-image: url(${imageUrl})"></div>
                  <div class="c-card-voice__label  c-label">${item.termname || ''}</div>
                </div>
                <div class="c-card-voice__content">
                  <div class="c-card-voice__title  c-heading is-sm">${title}</div>
                  <div class="c-card-voice__company">${companyName}</div>
                </div>
              </a>
            `;
            });
            if (html === '') {
              html = `<p class="u-text-center u-mbs is-md" style="width: 100%">現在準備中です</p>`;
            }

            document.getElementById('voiceDatas').innerHTML = html;
          })
          .then(() => {
            owls.imagesLoaded(function () {
            if ($('.js-card-voice-slider.owl-carousel').length <= 0) {
              return;
            }

            if ($('.c-card-voice__block').length <= 2) {
              $('.js-card-voice-slider').removeClass("owl-carousel");
              $('.js-card-voice-slider').wrap("<div class='l-container'></div>");
              return;
            }

            $('.js-card-voice-slider').owlCarousel({
              dots: true,
              loop: true,
              nav: true,
              autoplayHoverPause: true,
              autoplay: true,
              autoplaySpeed: 1000,
              autoWidth: true,
              autoHeight: false,
              speed: 400,
              items: 3,
              margin: 36,
              navContainer: ".c-card-voice .owl-nav",
              navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
              responsive: {
                // breakpoint from 0 up
                0: {
                  center: true,
                },
                // breakpoint from 750 up
                950: {
                  center: false,
                }
              }
            });
          })
          .catch((error) => {
            console.error('Error:', error);
          });
          });
      }

    }
    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '8';

      sr.reveal(".c-main-visual,.l-page-header", {
        duration: 1400,
        opacity: 1,
        //translateY: -baseDistance,
        delay: 900,
      }, 100);

      sr.reveal(".c-solution__wrap  > *",{
        scale: [0.9, 1],
        opacity: 1,
        duration: 600,
        delay: anime.stagger(100),
        translateX: [-baseDistance,0],
        easing: baseEasing
      });
      domEach(".c-card-sm__block", function(key, item){

        sr.reveal(item,{
          scale: {
            value: [0.9,1],
            // easing: "linear"
          },
          opacity: 1,
          duration: 600,
          delay: 100*key,
          translateY: [-baseDistance,0],
          easing: baseEasing
        } );
      });
    }



    // slick
    function slickSlider() {

      if ($('.js-gallery-slider').length <= 0 ){
        return false;
      }


      if ($('.c-gallery-slider__thumbnail .c-gallery-slider__thumbnail-image').length < 2) {
        $(".c-gallery-slider__thumbnail").addClass("is-simple-none");
      }

      // 上段
      $('.c-gallery-slider__main').slick({
        infinite: true,
        arrow: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><img src="../assets/images/icon-arrow-left.png" /></div>',
        nextArrow: '<div class="slick-next"><img src="../assets/images/icon-arrow-next.png" /></div>',
        asNavFor: '.c-gallery-slider__thumbnail',
        autoplaySpeed: 2500,
        // centerPadding: '23.28%',
        centerMode: true,
        variableWidth: true,
        dots: false,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 1
          }
        }]
      });

      // 下段
      $('.c-gallery-slider__thumbnail').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.c-gallery-slider__main',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 4
          }
        }]
      });
    }

    // ループスライダー
    function infiniteSlider() {
      const optionInfinite = {
        infinite: true,
        arrows: false,
        swipe: false,
        dots: false,
        variableWidth: true,  // スライド幅の自動計算を無効
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        pauseOnFocus: false,
        pauseOnHover: false
      }
      const slickInfinite = $('.js-infinite-slider');
      if (slickInfinite) $(slickInfinite).slick(optionInfinite);
    }


    function floatBar() {

      if (window.innerWidth >= 750) return;

      const bar = document.getElementById("float-bar");
      if (!bar) return;

      let lastKnownScrollPosition = 0;
      let ticking = false;


      function doSomething(scrollPos) {

        if (scrollPos === 0) {
          bar.classList.remove("is-active");
        } else if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {

          bar.classList.remove("is-active");
        } else {
          bar.classList.add("is-active");
        }
      }

      document.addEventListener('scroll', function(e) {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
          window.requestAnimationFrame(function() {
            doSomething(lastKnownScrollPosition);
            ticking = false;
          });

          ticking = true;
        }
      });

    }



    function tabSlickSlider() {


      const $gallery = $(".c-tabs__content.is-active");

      if ($gallery.find('.c-tabs__slider').length <= 0 || $gallery.find('.c-tabs__thumbnail').length <= 0){
        return false;
      }

      if ($gallery.find(".c-tabs__thumbnail .c-tabs__thumbnail-box").length < 2) {
        $gallery.find(".c-tabs__thumbnail").addClass("is-simple-none");
      }

      let num = $gallery.data("tabName") + 1;
      if(!num){
        num = 1;
      }


      let currentNum = $gallery.find('.c-tabs__paging .is-current');
      let lengthNum = $gallery.find('.c-tabs__paging .is-length');

      $gallery.find(`.c-tabs__slider`).not('.slick-initialized').on('init', function (event, slick) {
        currentNum.text(slick.currentSlide + 1);
        lengthNum.text(slick.slideCount);
      }).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        asNavFor: `.c-tabs__thumbnail.is-thumbnail-${num}`,
      }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        currentNum.text(nextSlide+1);
      })

      const thumbnailNum = $gallery.find(`.c-tabs__thumbnail-box`).length;

      if (thumbnailNum > 4) {
        $gallery.find(`.c-tabs__thumbnail`).removeClass("is-stick");
        $gallery.find(`.c-tabs__thumbnail-arrows`).addClass("is-hidden");
      }

      // 下段
      $gallery.find(`.c-tabs__thumbnail`).not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        margin: 12,
        asNavFor: `.c-tabs__slider.is-slider-${num}`,
        focusOnSelect: true,
        prevArrow:"<img class='is-prev' src='../assets/images/icon-slider-prev.svg'/>",
        nextArrow:"<img class='is-next' src='../assets/images/icon-slider-next.svg'/>",
        arrows: true
      });


      if (thumbnailNum <= 4) {
        const arrows = $gallery.find(`.c-tabs__thumbnail-arrow`);
        arrows.click(function (e) {
          if (e.target.classList.contains("is-next")) {
            $gallery.find(`.c-tabs__slider`).slick('slickNext');
          } else if (e.target.classList.contains("is-prev")) {
            $gallery.find(`.c-tabs__slider`).slick('slickPrev');
          }
        })
      }

    }

    function initSlider(currentContent) {
      const $gallery = $(currentContent);

      let num = $gallery.data("tabName") + 1;
      if(!num){
        num = 1;
      }

      if ($gallery.find(`.c-tabs__slider`).hasClass('slick-initialized')) {
        $gallery.find(`.c-tabs__slider`).slick('refresh');
        return;
      }

      let currentNum = $gallery.find('.c-tabs__paging .is-current');
      let lengthNum = $gallery.find('.c-tabs__paging .is-length');

      $gallery.find(`.c-tabs__slider`).not('.slick-initialized').on('init', function (event, slick) {
        currentNum.text(slick.currentSlide + 1);
        lengthNum.text(slick.slideCount);
      }).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        asNavFor: `.c-tabs__thumbnail.is-thumbnail-${num}`,
      }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        currentNum.text(nextSlide+1);
      })

      const thumbnailNum = $gallery.find(`.c-tabs__thumbnail-box`).length;

      if (thumbnailNum > 4) {
        $gallery.find(`.c-tabs__thumbnail`).removeClass("is-stick");
        $gallery.find(`.c-tabs__thumbnail-arrows`).addClass("is-hidden");
      }

      // 下段
      $gallery.find(`.c-tabs__thumbnail`).not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 4,
        arrows: true,
        slidesToScroll: 1,
        prevArrow:"<img class='is-prev' src='../assets/images/icon-slider-prev.svg'/>",
        nextArrow:"<img class='is-next' src='../assets/images/icon-slider-next.svg'/>",
        asNavFor: `.c-tabs__slider.is-slider-${num}`,
        focusOnSelect: true,
      });

      if (thumbnailNum <= 4) {
        const arrows = $gallery.find(`.c-tabs__thumbnail-arrow`);
        arrows.click(function (e) {
          if (e.target.classList.contains("is-next")) {
            $gallery.find(`.c-tabs__slider`).slick('slickNext');
          } else if (e.target.classList.contains("is-prev")) {
            $gallery.find(`.c-tabs__slider`).slick('slickPrev');
          }
        })
      }

    }

    function tabObserver() {
      const $tabsGallery = $(".c-tabs__slider");
      if ($tabsGallery.length <= 0) return;

      const attrObserver = new MutationObserver((mutations) => {
        mutations.every(mu => {
          if (mu.type !== "attributes" && mu.attributeName !== "class") return;
            const currentContent = $('.c-tabs__content.is-active');
            initSlider(currentContent);
        });
      });

      const ELS_test = document.querySelectorAll(".c-tabs__content");
      const nodes = Array.prototype.slice.call(ELS_test, 0);

      nodes.forEach(el => attrObserver.observe(el, {attributes: true}));

    }

    function getQueryString() {
      var key = false, res = {}, itm = null;
      // get the query string without the ?
      var qs = location.search.substring(1);
      // check for the key as an argument
      if (arguments.length > 0 && arguments[0].length > 1)
        key = arguments[0];
      // make a regex pattern to grab key/value
      var pattern = /([^&=]+)=([^&]*)/g;
      // loop the items in the query string, either
      // find a match to the argument, or build an object
      // with key/value pairs
      while (itm = pattern.exec(qs)) {
        if (key !== false && decodeURIComponent(itm[1]) === key)
          return decodeURIComponent(itm[2]);
        else if (key === false)
          res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
      }

      return key === false ? res : null;
    }

    function changeTab() {

      // const url = new URL(window.location.href);
      const tabNum = getQueryString("content");
        // url.searchParams.get("content");

      if (!tabNum) return;


      const nav = $(".c-tabs__navs");
      const contents = $(".c-tabs__content");


      if (!nav.length || !contents.length) return;
      const list = nav.find("li a");
      list.removeClass("is-active");
      $(list[tabNum]).addClass("is-active");
      contents.removeClass("is-active");
      $(contents[tabNum]).addClass("is-active");

    }

    function setBtnUrl() {
      const button = document.querySelector(".c-button.is-form-prev");
      if(!button) return;
      button.addEventListener("click", e => {
        e.preventDefault();
        window.history.go(-1)
      })
    }

    function ggModal() {
      const $modalBtn = $('.js-gg-modal');
      if ($modalBtn.length <= 0) return;

      $modalBtn.on('click', function(e) {
        e.preventDefault();
        $('.c-block-modal').toggleClass('is-visible');
        $('body').toggleClass('is-locked');
      });
    }

    function banner() {
      // 無料セミナー
      // var $banner_athlete = $(
      //   `<div class="c-cta">
      //   <div class="c-cta__block">
      //       <div class="c-cta__close">✕</div>
      //       <a href="/contact-download/document/?document_id=01" target="_blank">
      //           <img src="/assets/images/banner_whitepaper.png" alt=""/>
      //       </a>
      //   </div>
      // </div>`);
      var $banner = $(
        `<div class="c-cta">
          <div class="c-cta__block">
              <div class="c-cta__close">✕</div>
              <a href="/contact-download/document/?document_id=01 " target="_blank">
                  <img src="/assets/images/banner_whitepaper.png" alt=""/>
              </a>
          </div>
        </div>`
      );

      var $athleteBanner = $(
        `<div class="c-cta">
          <div class="c-cta__block">
              <div class="c-cta__close">✕</div>
              <a href="/contact-download/document/?document_id=02 " target="_blank">
                  <img src="/assets/images/banner_whitepaper.png" alt=""/>
              </a>
          </div>
        </div>`);

      // if (location.pathname === "/") {
      //     var $banner = $(`<div class="c-cta">
      //     <div class="c-cta__block">
      //         <div class="c-cta__close">✕
      //         </div><a href="https://dormybiz.lmsg.jp/form/10254/Si1mw1xh" target="_blank"><img class="u-hidden-sm" src="/documents/monthly_campaign/banner_202303_pc.jpg" alt=""/><img class="u-visible-sm" src="/documents/monthly_campaign/banner_202303_sp.png" alt=""/></a>
      //     </div>
      //     </div>`);
      // }
      // if (location.pathname === "/lp/monthly/") {
      //     var $banner = $("<div />");
      // }
      if (sessionStorage.getItem("close_banner")) {
        return false;
      }
      if ($("body").hasClass("athlete")) {
        $("body").append($athleteBanner);
      } else if ($("body").hasClass("contact-document")) {
        return;
      } else {
        $("body").append($banner);
      }
      var e = $(".c-cta__close"),
        i = $(".c-cta");
      e.click(function (e) {
        i.hide();
        sessionStorage.setItem("close_banner", true);
      });
      $(window).scroll(function () {
        var e = $(".l-offer,.l-footer").offset().top - $(window).height();
        $(window).scrollTop() > e && i.fadeOut("slow");
      });
    }

    $(function () {
      menuSlide();
      owlCarousel();
      reveal();
      slickSlider();
      floatBar();
      tabSlickSlider();
      tabObserver();
      changeTab();
      setBtnUrl();
      ggModal();
      banner();
    });
  }


}

window.GApp = new App();
